
<template>
  <div id="app">
    <router-view  v-wechat-title="$route.meta.title" ></router-view>
    <loading v-show="loading"/>  
  </div>
</template>
<script>
import loading from "@/components/loading"
import { mapGetters } from 'vuex'
export default {
  components:{
    loading
  },
  computed: {
    ...mapGetters([
        'loading',
    ]),
  }
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue